<template>
  <div>
    <MapModal
      v-if="modalIf.sceneInformation"
      title="保通方案"
      id="sceneInformationTree"
      :modalNode="modalNodeScenes"
      :submitData="submitPartData"
      :close="sceneInformationClose"
      :submit="onPartSubmit"
    ></MapModal>
    <!--  -->
    <MapModalPart
      v-if="modalIf.part"
      :contentHtml="submitPartData.content"
      :partStyle="partStyle"
      :class="submitPartData.areaLocation"
      :title="submitPartData.title"
      :ifLeftFold="ifLeftFold"
      :construction="true"
      @openEdit="openEdit"
    ></MapModalPart>
  </div>
</template>

<script>
const MapModal = () => import("@/components/common/mapModal/Index");
const MapModalPart = () => import("@/components/common/mapModal/Part");

import {
  BimSimConstructGetEnsurePass,
  BimSimConstructEdit,
  BimSimConstructAdd,
} from "@/api/api";

export default {
  components: {
    MapModal,
    MapModalPart,
  },
  computed: {
    SimId() {
      return this.$store.state.stageData.SimId;
    },
  },
  watch: {
    "submitPartData.width"(newData, oldData) {
      this.partStyle.w = newData + "px";
    },
    "submitPartData.height"(newData, oldData) {
      this.partStyle.h = newData + "px";
    },
    SimId: {
      deep: true,
      handler: function() {
        this.getData();
      },
    },
  },
  data() {
    return {
      modalNodeScenes: {
        sceneInformationTree: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 55,
            y: -425,
            // unit: "px", // 默认px
          },
          width: "420px", // 宽度配置 默认450px
          height: `${document.querySelector("#mars3d-container").offsetHeight -
            30}px`, // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: false,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          content: {
            type: "form",
            formData: {
              title: {
                md: 24,
                type: "input",
                title: "场景标题",
                placeholder: "请填场景标题",
              },
              // isAreaShow: {
              //   md: 24,
              //   type: "switch",
              //   title: "显示简介",
              //   placeholder: "请填场景标题",
              // },
              width: {
                md: 24,
                type: "input",
                title: "宽度",
              },
              height: {
                md: 24,
                type: "input",
                title: "高度",
              },
              areaLocation: {
                md: 24,
                type: "select",
                title: "简介定位",
                disabled: false,
                options: [
                  {
                    name: "左上",
                    id: "l-t",
                  },
                  {
                    name: "右上",
                    id: "r-t",
                  },
                  {
                    name: "左下",
                    id: "l-b",
                  },
                  {
                    name: "右下",
                    id: "r-b",
                  },
                  {
                    name: "居中",
                    id: "middle",
                  },
                ],
              },
              content: {
                md: 23,
                type: "rich",
                title: "简介内容",
                toolbar:
                  "undo redo | styleselect | bold italic forecolor | lists image table",
              },
            },
          },
          //模态框foot配置
        },
      },
      submitPartData: {
        title: "",
        content: "",
        isAreaShow: true,
        areaLocation: "l-t",
        alt: null,
        heading: null,
        lat: null,
        lng: null,
        pitch: null,
        duration: null,
        stop,
        width: "550",
        height: "400",
        id: null,
      },
      modalIf: {
        sceneInformation: false,
        part: false,
      },
      partStyle: {
        w: "550px",
        h: "400px",
        t: "85px",
        l: "270px",
        bg: "rgba(12,18,30,0.5)",
        ac: "#03e0ff",
      },
      ifLeftFold: false,
    };
  },
  methods: {
    getData() {
      if (this.$store.state.stageData?.SimId) {
        this.clearData();
        this.modalIf.part = true;
        BimSimConstructGetEnsurePass({
          SimId: window.sessionStorage.getItem("crossGroupSimId"),
          stage: this.$store.state.stageData.arr.charAt(
            this.$store.state.stageData.arr.length - 1
          ),
        }).then((res) => {
          console.log(res);
          if (res.data.data) {
            this.submitPartData.title = res.data.data.title;
            this.submitPartData.content = res.data.data.content;
            this.submitPartData.width = res.data.data.width;
            this.submitPartData.height = res.data.data.height;
            this.submitPartData.areaLocation = res.data.data.introPos;
            this.submitPartData.id = res.data.data.id;
          }

          // this.submitPartData.isAreaShow = res.data.data.showIntro;
        });
      } else {
        this.$message({
          message: "请先将时间轴拖动在阶段上！",
          type: "warning",
          duration: 1000,
        });
        // this.closeOneSelf();
      }
    },
    clearData() {
      this.submitPartData = {
        title: "",
        content: "",
        isAreaShow: true,
        areaLocation: "l-t",
        alt: null,
        heading: null,
        lat: null,
        lng: null,
        pitch: null,
        duration: null,
        stop,
        width: "550",
        height: "400",
        id: null,
      };
    },
    sceneInformationClose() {
      this.modalIf.sceneInformation = false
      this.clearData()
      this.$emit("closeEvaluationIndex");
    },
    onPartSubmit() {
      if (this.submitPartData.id) {
        BimSimConstructEdit({
          SimId: window.sessionStorage.getItem("crossGroupSimId"),
          Title: this.submitPartData.title,
          Content: this.submitPartData.content,
          introPos: this.submitPartData.areaLocation,
          width: this.submitPartData.width,
          height: this.submitPartData.height,
          // showIntro: this.submitPartData.isAreaShow,
          stage: this.$store.state.stageData.arr.charAt(
            this.$store.state.stageData.arr.length - 1
          ),
          id: this.submitPartData.id,
        }).then((res) => {
          this.$message({
            type: "success",
            message: "保存成功!",
          });
          this.modalIf.sceneInformation = false;
          // this.submitPartData.title = res.data.data.title;
          // this.submitPartData.content = res.data.data.content;
        });
      } else {
        BimSimConstructAdd({
          SimId: window.sessionStorage.getItem("crossGroupSimId"),
          Title: this.submitPartData.title,
          Content: this.submitPartData.content,
          introPos: this.submitPartData.areaLocation,
          width: this.submitPartData.width,
          height: this.submitPartData.height,
          // showIntro: this.submitPartData.isAreaShow,
          stage: this.$store.state.stageData.arr.charAt(
            this.$store.state.stageData.arr.length - 1
          ),
        }).then((res) => {
          this.$message({
            type: "success",
            message: "保存成功!",
          });
          this.modalIf.sceneInformation = false;
          // this.submitPartData.title = res.data.data.title;
          // this.submitPartData.content = res.data.data.content;
        });
      }
    },
    openEdit() {
      this.modalIf.sceneInformation = true;
    },
  },
  created() {
    this.getData();
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.program-change-information-head {
  position: absolute;
  width: 100%;
  top: 0;
  height: 54px;
  background: #0c121e;
  z-index: 9999;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
}
.program-head-enter,
.program-head-leave-to {
  top: -60px;
}
.program-head-enter-active,
.program-head-leave-active {
  transition: all 1s;
}

.program-change-information-left-menu {
  position: absolute;
  left: 0;
  top: 54px;
  width: 252px;
  bottom: 0;
  background: #0c121e;
  z-index: 9999;
  padding-top: 6px;
  transition: all 0.5s;
  /deep/ .el-scrollbar__wrap {
    overflow-x: auto;
  }
  /deep/ .el-collapse {
    border: 0;
    color: #ccc;
    // padding: 0 20px;
    .el-collapse-item {
      padding: 0 20px;
      // border-bottom: 1px solid #ccc;
      &:hover {
        color: #fff;
        background: #1d273b;
        .el-collapse-item__header {
          color: #fff;
        }
      }
      &:last-child {
        border-bottom: 0;
      }
      .el-collapse-item__content {
        padding-bottom: 10px;
      }
    }
    .is-active {
      color: #fff;
      background: #1d273b;
      .el-collapse-item__header {
        color: #fff;
      }
    }
    .el-collapse-item__header {
      line-height: initial;
      color: #ccc;
      background-color: transparent;
      border: 0;
      border-bottom: 1px solid #6a6a6a;
    }
    .el-collapse-item__wrap {
      border: 0;
      margin: 0 -20px;
      background: #0c121e;
    }
  }
  .program-add {
    margin-bottom: 10px;
    padding: 0 5px;
  }
  .menu-title-input {
    /deep/ input {
      border: 0;
      background: transparent;
      color: #fff;
      padding: 0;
      font-size: 13px;
    }
  }
}
.program-left-menu-enter,
.program-left-menu-leave-to {
  left: -265px;
}
.program-left-menu-enter-active,
.program-left-menu-leave-active {
  transition: all 1s;
}
.sys-area {
  display: flex;
  height: 100%;
  align-items: center;
}
.story-name {
  font-size: 16px;
  color: #ccc;
}
.op-area {
  height: 100%;
  /deep/ .program-el-menu {
    height: 100%;
    border: 0;
    background: transparent !important;
    .el-menu-item {
      background: transparent !important;
      padding: 0;
      border: 0;
      height: 100%;
      line-height: initial;
      width: 80px;
    }
    .el-submenu {
      .el-submenu__title {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 20px;
        border: 0;
        line-height: initial;
        height: 54px;
        width: 80px;
        .menu-item {
          padding: 0;
        }
        &:hover {
          background: #1d273b;
          .menu-item {
            color: #fff;
          }
          i {
            color: #fff;
          }
        }
      }
      .el-submenu__icon-arrow {
        position: absolute;
        right: 5px;
        top: 45%;
      }
    }
    .is-active {
      background: #1d273b !important;
      .menu-item {
        color: #fff;
      }
      i {
        color: #fff;
      }
    }
  }
}

.tool-library-li {
  padding: 0 !important;
  .menu-item {
    flex-direction: row;
    width: 100%;
    justify-content: left;
    i {
      margin: 0 5px 0 0;
    }
  }
}
.menu-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 12px;
  color: #cccccc;
  height: 100%;
  padding: 0 20px;
  cursor: pointer;
  i {
    font-size: 18px;
    margin: 0 0 3px 0;
  }
  i.las {
    font-size: 22px;
    margin: 0;
  }
  i.el-icon-video-play {
    font-size: 20px;
  }
  &:hover {
    color: #fff;
    background: #1d273b;
    i {
      color: #fff;
    }
  }
}
.el-collapse-item__header:hover .program-left-menu-title i {
  opacity: 1;
}
.program-left-menu-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  .operation-view {
    padding: 0 5px;
    display: flex;
    height: 100%;
    align-items: center;
    i {
      color: #ccc;
      padding: 0 5px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      &:hover {
        color: #fff;
      }
      opacity: 0;
    }
  }
}

.program-thumbnail {
  padding: 0;
  list-style-type: none;
  margin-bottom: 0;
  li {
    padding: 5px;
    display: flex;
    align-items: center;
    color: #ccc;
    // height: 82px;
    &.active {
      color: #fff;
      background: #1d273b;
    }
    &.transition {
      height: auto;
      padding: 0;
    }
    &:last-child {
      height: auto;
      padding: 0;
    }
    &:not(:last-child) {
      cursor: pointer;
      &:hover {
        background: #1d273b;
        color: #fff;
      }
    }
    /deep/ img {
      width: 100px;
      max-height: 72px;
      min-height: 30px;
    }
    .program-thumbnail-time {
      height: 100%;
      width: 140px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      min-height: 30px;
      time {
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .program-thumbnail-time-button {
        display: flex;
        justify-content: flex-end;
        padding-right: 5px;
        // display: none;
        i {
          margin: 0 2px;
          color: #ccc;
          font-size: 14px;
          &:hover {
            color: #fff;
          }
        }
      }
      &:hover {
        .program-thumbnail-time-operate {
          opacity: 1;
        }
      }
      .program-thumbnail-time-operate {
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0;
        i {
          font-size: 14px;
          margin: 0 4px;
          color: #ccc;
          &:hover {
            color: #fff;
          }
        }
      }
    }
    .el-tree {
      background: transparent;
      width: 100%;
      color: #ccc;
      /deep/.el-tree-node__content:hover {
        background: transparent;
        color: #fff;
      }
      /deep/.el-tree-node:focus > .el-tree-node__content {
        background: transparent;
      }
    }
  }
  .program-button {
    margin-top: 10px;
  }
}
.program-button {
  background-color: transparent;
  color: #ccc;
  padding: 5px;
  width: 100%;
  border: 1px dashed #ccc;
  &:hover {
    background-color: #fff;
    color: #000;
    border: 1px solid #fff;
  }
}
/deep/ #introduce {
  z-index: 9999;
  background: rgba(30, 36, 50, 1) !important;
  text-align: center;
  color: #fff;
  .introduce-content {
    padding: 55px 90px;
    h2 {
      font-size: 32px;
      font-weight: 600;
      margin-bottom: 60px;
    }
    p {
      font-size: 20px;
      text-align: left;
    }
  }
}

/deep/ .textViewTestP {
  display: none;
}
/deep/ .textViewTest:hover {
  .textViewTestP {
    display: block;
  }
}
.program-thumbnail-add {
  margin: 10px 15px 0 15px;
}

/deep/ .el-collapse-item__arrow {
  order: -1;
}
.el-dropdown {
  color: #ccc;
  font-size: 14px;
}
.if-left-fold .fold-operation {
  transform: rotate(180deg);
}
.fold-operation {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: absolute;
  height: 46px;
  width: 14px;
  // border-width: 1px;
  // border-style: solid;
  box-sizing: border-box;
  padding: 0;
  z-index: 999;
  border-radius: 0 0;
  border-top-right-radius: 3px 3px;
  border-bottom-right-radius: 3px 3px;
  z-index: 2002;
  right: -14px;
  top: 50%;
  background: #0c121e;
  margin-top: -23px;
  cursor: pointer;
  opacity: 0.6;
}
.if-left-fold {
  left: -252px;
  transition: all 0.5s;
}
/deep/ .el-popper {
  min-width: auto;
}
/deep/ #scenerResourceTree {
  transition: all 0.5s;
}
.if-left-resources /deep/ #scenerResourceTree {
  left: 0 !important;
}
.tool-library-li {
  .menu-item i {
    margin: 0 10px 0 0;
    font-size: 18px;
  }
}
.transparent_value {
  /deep/.el-form-item {
    margin-bottom: 0px;
    // height: 35px;
    line-height: 35px;
  }
}
</style>
